import React, {Component, KeyboardEvent} from 'react';
import {CategoryRepository, ISearchedCategory} from "repositories/category/CategoryRepository";
import {SsqImages} from "images/SsqImages";
import {LanguageService} from "language/LanguageService";
import {RouteComponentProps, withRouter} from "react-router-dom";
import parse from "html-react-parser";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import styled from "styled-components";
import {LocalStorageWrapper, RECENT_SEARCH_VALUE_STORAGE_KEY} from "util/LocalStorageWrapper";
import {getHighlightedTextFromHtml, saveAndLoadRecentSearch} from "util/commonUtils";
//import {InfoPopup} from "footer/InfoPopup";
import {AllPopupWrap} from "footer/Footer";
import axios from "axios";
import {emptyISearchFilterRequest, SearchRepository2} from "repositories/SearchRepository2";
import related_arrow from "../images/common/related_arrow.svg";
import {isEmpty, join} from 'lodash-es';
import {langutil} from "language/langutil";
import {cookieutil} from "util/cookieutil";
import {AllPopupOverlay} from "style/CommonStyledComponents";

const InfoPopup = React.lazy(() => import( "footer/InfoPopup").then(module => ({default: module.InfoPopup})));

interface Props extends RouteComponentProps<any> {
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  searchInput: string;
  searchRepository2: SearchRepository2;
  setSearchInput?: Function;
  defaultFocusedInput?: boolean;
  onClickCloseButton?: Function;
  onFocusSearchInput?: Function;
  searchCheckbox?: boolean;
  setSearchCheckbox?: Function;
  localStorageWrapper: LocalStorageWrapper;
  isAllSearchPage?: boolean;
  searchInResultCheckbox?: boolean;
  setSearchInResultCheckbox?: Function;
  speller?: string;
  nonDisplayRelated?: boolean;
}

interface State {
  showAutocompletePopup: boolean;
  searchRelatedSuggestionList;
  searchCategorySuggestionList;
  searchModelSuggestionList;
  searchInput: string;
  originalSearchInput: string;
  recentSearchInputs: string[] | undefined;
  allAutocompleteUrlList: string[];
  selectedAutocompleteItemIndex: number;
  selectedRecentSearchItemIndex: number;
  showInfoPopup: boolean;
  speller: string;
  related: string[];
  autoCompleteInput: string;
  activateRecentKeyword: boolean;
}

class SearchBoxPopup2 extends Component<Props, State> {
  searchInputTimer: any = null;
  readonly SEARCH_DEBOUNCING_DELAY_TIME_MS = 300;
  readonly INITIAL_SELECTED_INPUT_INDEX = -1;
  private readonly searchInputRef: React.RefObject<HTMLInputElement>;
  private readonly suggestRef: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);

    this.searchInputRef = React.createRef();
    this.suggestRef = React.createRef();
    this.state = {
      searchRelatedSuggestionList: [],
      searchCategorySuggestionList: [],
      searchModelSuggestionList: [],
      searchInput: this.props.searchInput,
      autoCompleteInput: '',
      originalSearchInput: this.props.searchInput,
      recentSearchInputs: this.props.localStorageWrapper?.getItem(RECENT_SEARCH_VALUE_STORAGE_KEY)?.split(",").reverse(),
      allAutocompleteUrlList: [],
      selectedAutocompleteItemIndex: this.INITIAL_SELECTED_INPUT_INDEX,
      selectedRecentSearchItemIndex: 0,
      showAutocompletePopup: false,
      showInfoPopup: false,
      speller: '',
      related: [],
      activateRecentKeyword: false
    };
  }

  async componentDidMount() {
    if (this.props.defaultFocusedInput) {
      this.searchInputRef.current?.focus();
    }

    if (!this.props.nonDisplayRelated) {
      const relatedValue = await this.props.searchRepository2.getRelatedSearchData(this.state.searchInput);
      this.setState({related: relatedValue});
    }

    if (cookieutil.isAcceptFunctionConsentCookie(this.props.languageService.lang())) this.setState({activateRecentKeyword: true});

    document.addEventListener('mouseup', this.handleClickOutside.bind(this));
  }

  handleClickOutside(e: MouseEvent) {
    if ((this.searchInputRef.current && !this.searchInputRef.current.contains(e.target as Node)) && (this.suggestRef.current && !this.suggestRef.current.contains(e.target as Node))) {
      this.setState({showAutocompletePopup: false});
    }
  }

  shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): boolean {
    if (nextProps.searchCheckbox !== this.props.searchCheckbox)
      return true;
    return true;
  }

  componentWillUnmount() {
    if (this.searchInputTimer) {
      clearTimeout(this.searchInputTimer);
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if ((this.props.speller !== prevProps.speller) && (this.props.speller && this.props.speller !== '')) this.setState({speller: this.props.speller});
  }

  getTranslatedText(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_MAIN_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  onChangeSearchInput(searchInput: string) {
    this.setState({
      searchInput,
      originalSearchInput: searchInput
    });

    if (this.props.setSearchInput)
      this.props.setSearchInput(searchInput);

    if (searchInput) {
      this.generateSearchedRelatedAndCategoriesAndModels(searchInput);
    } else {
      this.setState({
        searchCategorySuggestionList: [],
      });
    }
  }

  async getAutoCompleteResults(searchInput: string) {
    const suggests = await this.props.searchRepository2.getSuggest(searchInput, this.props.languageService.getLanguage());

    const categories = await this.props.searchRepository2.getNewCategorySearchData(
      {...emptyISearchFilterRequest, searchKeyword: searchInput, lang: this.props.languageService.getLanguage(), page: 1, size: 5}
    );

    return {suggests, categories};
  }

  generateSearchedRelatedAndCategoriesAndModels(searchInput: string) {
    if (this.searchInputTimer) {
      clearTimeout(this.searchInputTimer);
    }
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    this.searchInputTimer = setTimeout(async () => this.getAutoCompleteResults(searchInput).then(result => {
      let searchCategorySuggestionList = [];
      let searchRelatedSuggestionList: { suggestName: string, highlightedResultElement: any }[] = [];
      let allAutocompleteUrlList: string[] = [];
      let searchModelSuggestionList = [];

      result.suggests.forEach((suggest, i) => {
        const suggestName = suggest.word;
        searchRelatedSuggestionList.push({
          suggestName: suggestName,
          highlightedResultElement: <div className={"related-search-suggest-item"}>
            <span className={"related-name"}>{parse(suggest.highlight)}</span>
          </div>
        });
        allAutocompleteUrlList.push(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(suggestName)}`);
      });

      result.categories.items.forEach(autoCompleteItem => {
        let splittedCategory = autoCompleteItem.category.split('/');
        splittedCategory[splittedCategory.length - 1] = autoCompleteItem.name;
        let itemModels = [];

        autoCompleteItem.related_models &&
        autoCompleteItem.related_models.map(model => {
          if (model.includes("<b class='search_highlight'>")) {
            itemModels.push(model);
          }
        });


        searchModelSuggestionList.push(itemModels);
        searchCategorySuggestionList.push({
          id: autoCompleteItem.id,
          highlightedResultElement: <div className={"category-search-suggest-item"}>
            {parse(getHighlightedTextFromHtml(join(splittedCategory, '/')))}
          </div>
        });
        allAutocompleteUrlList.push(`/product/category/${autoCompleteItem.id}`);
      });

      this.setState({
        searchModelSuggestionList,
        searchRelatedSuggestionList,
        searchCategorySuggestionList,
        allAutocompleteUrlList
      });
    }).catch(e => console.log(e)), this.SEARCH_DEBOUNCING_DELAY_TIME_MS);
  }

  moveToClickUrl(url: string) {
    this.props.onClickCloseButton && this.props.onClickCloseButton();
    window.open(url, "_self");
  }

  isSearchPopup(): boolean {
    return this.props.onClickCloseButton && true || false;
  }

  getSearchPopupClassName(): any {
    if (this.isSearchPopup())
      return "popup";
    else if (this.props.isAllSearchPage && this.props.isAllSearchPage)
      return "allSearch";
    else
      return "main";
  }

  /*ToDo : Not Tested*/
  setRecentSearchInputs() {
    if (this.state.searchInput != "") {
      if (cookieutil.isAcceptFunctionConsentCookie(this.props.languageService.lang())) {
        this.setState({
          recentSearchInputs: saveAndLoadRecentSearch(
            this.props.localStorageWrapper, this.state.searchInput
          )
        });
      }
    }
  }

  /*ToDo : Not Tested*/
  onKeyDownForRecentSearch(e: KeyboardEvent<HTMLInputElement>) {
    let {selectedRecentSearchItemIndex, recentSearchInputs} = this.state;
    const resultCount = recentSearchInputs?.length;
    let presentIndex: number = 0;

    if (e.key === "ArrowDown") {
      presentIndex = selectedRecentSearchItemIndex + 1;
      if (resultCount && presentIndex > resultCount) {
        presentIndex = 0;
      }
    } else if (e.key === "ArrowUp") {
      presentIndex = selectedRecentSearchItemIndex - 1;
      if (resultCount && presentIndex < 0) {
        presentIndex = resultCount;
      }
    } else if (e.key === "Enter") {
      // if (selectedRecentSearchItemIndex === 0) {
      //     this.moveToClickUrl(`/${country}/${lang}/newSearch?searchInput=${this.state.searchInput}`);
      // } else {
      //   recentSearchInputs && window.open(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(recentSearchInputs[selectedRecentSearchItemIndex - 1])}`, "_self");
      // }
    }
    this.setState({
      selectedRecentSearchItemIndex: presentIndex
    });
  }

  setSelectedAutocompleteItem(selectedAutocompleteItemIndex: number) {
    if (selectedAutocompleteItemIndex === this.INITIAL_SELECTED_INPUT_INDEX) {
      this.setState({
        searchInput: this.state.originalSearchInput
      });
    } else {
      if (selectedAutocompleteItemIndex < this.state.searchRelatedSuggestionList.length) {
        this.setState({
          searchInput: this.state.searchRelatedSuggestionList[selectedAutocompleteItemIndex].suggestName,
          selectedAutocompleteItemIndex
        });
      } else {
        this.setState({
          searchInput: this.state.originalSearchInput,
          selectedAutocompleteItemIndex
        });
      }
    }
  }

  async openUrl() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    if (!isEmpty(this.state.searchInput.trim()))
      await axios.get(`/api/speller?query=${encodeURIComponent(this.state.searchInput)}`).then(spellCheck => {
        if (spellCheck.data.speller) {
          window.open(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(spellCheck.data.speller)}&alt=${encodeURIComponent(this.state.searchInput)}`, "_self");
        } else window.open(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(this.state.searchInput)}`, "_self");
      });
  }

  /*ToDo : Not Tested*/
  async onKeyDownSearch(e: KeyboardEvent<HTMLInputElement>) {
    let selectedAutocompleteItemIndex = this.state.selectedAutocompleteItemIndex;
    let autocompleteItemCount = this.state.allAutocompleteUrlList.length;

    if (e.key === "ArrowDown") {
      selectedAutocompleteItemIndex++;
      if (selectedAutocompleteItemIndex > autocompleteItemCount) {
        selectedAutocompleteItemIndex = 0;
      }
      this.setSelectedAutocompleteItem(selectedAutocompleteItemIndex);
    } else if (e.key === "ArrowUp") {
      selectedAutocompleteItemIndex--;
      if (selectedAutocompleteItemIndex < 0) {
        selectedAutocompleteItemIndex = autocompleteItemCount;
      }
      this.setSelectedAutocompleteItem(selectedAutocompleteItemIndex);
    } else if (e.key === "Enter") {
      if (selectedAutocompleteItemIndex < this.state.searchRelatedSuggestionList.length) {
        if (this.state.activateRecentKeyword) this.setRecentSearchInputs();
        await this.openUrl();
      } else {
        window.open(this.state.allAutocompleteUrlList[selectedAutocompleteItemIndex], "_self");
      }
    }
  }

  isAllSearchPage() {
    if (this.props.history.location.pathname.includes("newSearch"))
      return true;
    return false;
  }

  showInfoPopupFunc = (showInfoPopup: boolean) => {
    this.setState({showInfoPopup: showInfoPopup});
  };

  renderAutocompletePopup() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    return <>
      <div aria-label={"search-suggest"}
        ref={this.suggestRef}
        className={"search-suggest " + (this.state.searchRelatedSuggestionList.length > 0 || this.state.searchCategorySuggestionList.length > 0 ? "search-suggest-show" : "")}>
        {/*ToDo : Not Tested*/}
        {this.state.activateRecentKeyword && this.state.recentSearchInputs && !this.state.searchInput && (this.isSearchPopup() || this.isAllSearchPage()) &&
          <div className={"recent-search-suggest"}>
            <div className={"search-result-type"}>
              {this.getTranslatedText("I18N_MAIN_SEARCH_RECENT_SEARCH")}
            </div>
            {this.state.recentSearchInputs?.map((recentInput, index) => <div
              key={index}
              onClick={() => {
                this.setState({
                  searchInput: recentInput,
                  showAutocompletePopup: false
                });
                this.moveToClickUrl(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(recentInput)}`);
              }}
              className={this.state.selectedRecentSearchItemIndex === index + 1 ? "suggest-item-selected" : "suggest-item"}>
              <button className={"search-result"}>
                <img alt={"related_search_result_icon.svg"}
                  className={"related-search-result-icon"}
                  src={SsqImages.common.icon.recentSearchIcon()}
                />
                <span className={"related-search-result-text"}>{recentInput}</span>
              </button>
            </div>)}
          </div>
        }
        {/*ToDo : Not Tested*/}
        {this.state.searchInput && this.state.searchRelatedSuggestionList.length > 0 &&
          <div className={"related-search-suggest"}>
            <div className={"search-result-type"}>
              {this.getTranslatedText("I18N_MAIN_SEARCH_RESULT_RELATION")}
            </div>
            {this.state.searchRelatedSuggestionList.map((item, index) => <div
              key={index}
              className={this.state.selectedAutocompleteItemIndex === index ? "suggest-item-selected" : "suggest-item"}
              onClick={() => {
                this.setState({
                  searchInput: item.suggestName,
                  showAutocompletePopup: false
                });
                this.moveToClickUrl(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(item.suggestName)}`);
              }}>
              <button className={"search-result"}>
                <img alt={"related_search_result_icon.svg"}
                  className={"related-search-result-icon"}
                  src={SsqImages.common.icon.relatedSuggestResultIcon()}
                />
                <span
                  className={"related-search-result-text"}>{item.highlightedResultElement}</span>
              </button>
            </div>)}
          </div>}

        {this.state.searchInput && this.state.searchCategorySuggestionList.length > 0 &&
          <div aria-label={"search-suggest-category"} className={"search-suggest-category"}>
            <div className={"search-result-type"}>
              {this.getTranslatedText("I18N_MAIN_SEARCH_RESULT_CATEGORY")}
            </div>
            {this.state.searchCategorySuggestionList.map((item: ISearchedCategory, index) =>
              <div
                key={index}
                className={this.state.selectedAutocompleteItemIndex - this.state.searchRelatedSuggestionList.length === index ? "suggest-item-selected" : "suggest-item"}
                onClick={() => {
                  this.moveToClickUrl(`/product/category/${item.id}`);
                }}
              >
                <button className={"search-result"}>
                  <img alt={"search_result_icon.svg"}
                    className={"search-result-icon"}
                    src={SsqImages.common.icon.searchResultImg()}
                  />
                  <span className={"search-result-text"}>{item.highlightedResultElement}</span>
                </button>
                {/* todo: 모델추가 */}
                <div className={'flex flex-row related-model'}>
                  {this.state.searchModelSuggestionList[index].map((model, i) => (
                    <span key={i}>
                      {parse(getHighlightedTextFromHtml(model))}
                    </span>
                  ))}
                </div>
              </div>)}
          </div>}
      </div>
    </>;
  }

  render() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    return (
      <SearchBandContainer className={this.getSearchPopupClassName()}>
        <SearchBand className={"search-band"}>
          <div className={"search-input-wrap"}>
            <div className={"search-input-box"}>
              <input
                ref={this.searchInputRef}
                value={this.state.searchInput}
                className={"search-input"}
                aria-label={"search-input"}
                placeholder={this.getTranslatedText("I18N_MAIN_SEARCH_PLACEHOLDER")}
                onFocus={(e) => {
                  this.props.onFocusSearchInput && this.props.onFocusSearchInput();
                  this.setState({showAutocompletePopup: true});
                }}
                onChange={(e) => {
                  this.onChangeSearchInput(e.target.value);
                }}
                onKeyDown={(e) => {
                  this.state.searchInput ? this.onKeyDownSearch(e) : this.onKeyDownForRecentSearch(e);
                }}
              />

              <div className={"close-small-icon-div"}>
                {this.state.searchInput &&
                  <img className={"close-small-icon"} alt={"close_small_icon.svg"}
                    src={SsqImages.common.icon.closeSmallIcon()}
                    onClick={() => this.onChangeSearchInput("")}
                  />}
              </div>
              {(this.getSearchPopupClassName() === "popup" || this.state.showAutocompletePopup) && this.renderAutocompletePopup()}
            </div>
            <div>
              <button className={"search-button"}
                onClick={async () => {
                  if (this.state.activateRecentKeyword) this.setRecentSearchInputs();
                  if (this.props.setSearchInput)
                    this.props.setSearchInput("");
                  await this.openUrl();
                }}>
                {this.getTranslatedText("I18N_MAIN_SEARCH")}
              </button>
            </div>
          </div>
          {this.props.speller && (this.props.speller !== '') && (
            <div className={'speller'}>
              <div className={'speller-name'}>{this.props.searchInput}</div>
              <div className={'speller-desc'}>{this.getTranslatedText("I18N_MAIN_SEARCH_SPELLER")}</div>
              <div className={'srch-speller cursor-pointer'} onClick={() => {
                window.open(`/${country}/${lang}/newSearch?searchInput=${encodeURIComponent(this.props.speller)}`, "_self");
              }}> {this.props.speller} {this.getTranslatedText("I18N_MAIN_SEARCH_SPELLER_VIEW")}
              </div>
            </div>
          )}
          {this.state.related.length > 0 && (
            <div className={'related'}>
              <div>
                <div className={'related-tit'}>
                  {this.getTranslatedText("I18N_MAIN_SEARCH_RELATION")}
                </div>
                <div className={'related-item'}>
                  {this.state.related.map((keyword, i) => (
                    <span key={i} className={'cursor-pointer'} onClick={() => {
                      window.open(`/${country}/${lang}/newSearch?searchInput=${keyword}`, "_self");
                    }}>
                  {keyword}
                      <img src={related_arrow} alt={''}/>
                </span>
                  ))
                  }
                </div>
              </div>
            </div>
          )}

        </SearchBand>
        {
          this.props.onClickCloseButton && <button className={"close-icon-btn"}>
            <img className="close-icon non_mobile" alt={"search_close_icon.svg"}
              src={SsqImages.dashboard.searchCloseImage()}
              onClick={() => this.props.onClickCloseButton && this.props.onClickCloseButton()}
            />
            <img className="close-icon mobile" alt={"search_close_icon.svg"}
              src={SsqImages.header.icon.mobilesearchclose()}
              onClick={() => this.props.onClickCloseButton && this.props.onClickCloseButton()}
            />
          </button>
        }
        <div className={"tip_button"} onClick={() => {
          this.setState({showInfoPopup: true});
        }}>
          <img className={""} alt={"tip_icon.svg"}
            src={SsqImages.dashboard.tip()}/>
          <p>{this.getTranslatedText("I18N_MAIN_TIP")}</p>
        </div>
        <AllPopupWrap>
          {this.state.showInfoPopup && this.renderInfoPopup()}
        </AllPopupWrap>
        {this.state.showInfoPopup &&
          <AllPopupOverlay
            aria-label={"popup-overlay"}
          />}
      </SearchBandContainer>
    );
  }

  private renderInfoPopup() {
    return <React.Suspense fallback={null}><InfoPopup
      languageService={this.props.languageService}
      showInfoPopupFunc={this.showInfoPopupFunc}
    /></React.Suspense>;
  }
}

export default withRouter(SearchBoxPopup2);

const SearchBandContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 120rem;
  width: 100%;
  height: 12rem;
  background-color: rgba(42, 44, 47, 0.9);

  .search-input-box {
    height: 6.4rem;
    background-color: #fff;
    border-radius: 3.2rem 0 0 3.2rem;
  }

  .tip_button {
    display: none
  }

  &.main {
    .tip_button {
      width: 6.4rem;
      height: 6.4rem;
      cursor: pointer;
      margin-left: 2.4rem;
      display: block;
      border-radius: 4px;
      text-align: center;
      padding: .8rem 0;

      :hover {
        background: rgba(255, 255, 255, 0.1);
      }

      :active {
        background: rgba(255, 255, 255, 0.3);
      }

      > img {
        opacity: .8;
      }

      > p {
        font-size: 1rem;
        color: #DDE2E9;
        margin-top: .4rem;
      }
    }
  }

  &.popup {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    padding: 0 8rem;
    animation-duration: 0.5s;
    animation-name: searchbottom;
    @keyframes searchbottom {
      from {
        transform: translateY(-100%)
      }

      to {
        transform: translateY(0);
      }
    }

    .search-input {
      z-index: 11;
    }
  }

  &.main {
    position: relative;
  }

  &.allSearch {
    background: none;
    height: 100%;

    .search-input-wrap {
      box-shadow: 0px 4px 12px rgb(0 0 0 / 10%);
      border-radius: 3.2rem;
    }

    .speller {
      display: flex;
      font-size: 1.3rem;
      line-height: 1.9rem;
      margin-top: 1rem;
      width: 70rem;
      padding-left: 5rem;
      overflow: hidden;
    }

    .speller-name {
      ${fontFamilyMedium};
      color: #2A2C2F;
    }

    .speller-desc {
      ${fontFamilyRegular};
      color: #7783A1;
      margin-right: 0.4rem;
    }

    .srch-speller {
      ${fontFamilyMedium};
      color: #407EDB;
    }

    .search-band {
      background: #EAEEF5;
      box-shadow: rgb(0 0 0 / 10%) 0px -20px 20px;
      z-index: 2;
      width: 120rem;
      display: flex;
      flex-direction: column;
    }

    .checkbox-div label {
      color: #2A2C2F;
    }

    .search-suggest {
      box-shadow: inset 0px 12px 10px -10px rgb(0 0 0 / 10%) !important;
      border: solid 1px #DDE2E9;
      border-top: none;
    }

    .search-result-text {
      flex-shrink: 0
    }

    .search-input {
      z-index: 11;
    }
  }

  .close-icon-btn {
    width: 2.8rem;
    height: 2.8rem;

    display: flex;
    align-items: end;
    position: absolute;
    top: calc(50% - 1.4rem);
    left: 97%;
    z-index: 11;

    .close-icon {
      width: 2.8rem;
      height: 2.8rem;
    }
  }

  @media screen and (max-width: 1199px) {
    //height: 15rem !important;
    min-width: inherit;
    padding: 0 2.4rem;
  }
  @media screen and (min-width: 765px) and (max-width: 1199px) {
    .search-band {
      max-width: 700px;
      position: relative;
    }

    .checkbox-div {
      position: absolute;
      top: -45%;
    }

    .search-input-wrap {
      margin: .9rem auto !important;
    }

    &.main {
      .tip_button {
        margin-left: .8rem;
      }
    }

    &.popup {
      .search-input {
        width: 100% !important;
        padding: 0 4.8rem;
      }

      .close-icon-btn {
        left: 93%;
      }

      .search-suggest {
        width: calc(100% - 32px) !important;
      }
    }

    &.allSearch {
      background: #EAEEF5;
      //height: 12rem !important;

      .search-band {
        background: none;
        box-shadow: none;
      }
    }
  }
  @media screen and (max-width: 764px) {
    background: none;
    height: auto !important;
    margin-bottom: 1.4rem;

    .search-button {
      width: 96px !important;
      height: 57px !important;
      font-size: 14px !important;
    }

    .search-input-box {
      width: calc(100% - 96px) !important;

      .search-input {
        height: 62px !important;

        ::placeholder {
          color: #666E7A;
          font-size: 11px !important;
        }
      }
    }

    &.main {
      .search-band {
        position: absolute;
        padding: 0 2.4rem;
        top: 0;
        z-index: 2;
      }

      .tip_button {
        margin-left: 0;
        position: absolute;
        right: 1rem;
        bottom: 17rem;
        z-index: 2;

        > img {
          opacity: 1 !important;
          display: inline-block;
        }

        > p {
          color: #fff !important;
          margin: 0 !important;
        }
      }

      .search-input {
        height: 57px !important;
      }
    }

    &.popup, &.allSearch {
      padding: 0 !important;

      .search-band {
        //height: 64px !important;
        position: relative;
      }

      .search-input-wrap {
        border-radius: 0;

        .search-input-box {
          width: calc(100% - 40px) !important;
          position: initial;
        }

        .recent-search-suggest, .search-suggest-show {
          border-top: 2px solid rgb(64, 125, 217);
        }

        .search-input {
          border-radius: 0 !important;
          background-image: none;
          padding: 0 30px 0 0;
        }

        .search-button {
          border-radius: 0 !important;
          background: #fff url(${SsqImages.header.icon.mobilesearch()}) center right no-repeat !important;
          width: 40px !important;
          height: 64px !important;
          font-size: 0 !important;
        }

        .search-suggest {
          width: 100% !important;
          top: 63px !important;
          left: 0;
          border-radius: 0 !important;
          z-index: 15;
        }

        .close-small-icon-div {
          right: 47px;
          width: 30px;
          justify-content: end;
          top: 2.4rem;

          img {
            margin-right: 0 !important;
          }
        }
      }
    }

    &.popup {
      top: 0rem !important;

      .close-icon-btn {
        top: 2.2rem;
        right: auto;
        left: 1.6rem;
      }

      .search-input-wrap {
        position: absolute;
        top: 0;
        width: 100%;
        background: #fff;
        padding: 0 11px 0 48px;
        max-width: 100%;

        .search-suggest {
          box-shadow: none;
        }
      }
    }

    &.allSearch {
      margin: 0;
      background: #fff;
      max-width: 100%;
      position: sticky;
      top: 83px;
      z-index: 10;

      .search-band {
        background: none;
        box-shadow: none;
        padding-bottom: 1rem;

        .search-input-wrap {
          width: 100%;
          box-shadow: none;
          padding: 0 11px 0 16px;
          max-width: 100%;
          border-bottom: solid 2px #407DD9;

          .search-suggest {
            max-height: 60vh;
            box-shadow: 0px 12px 10px -10px rgb(0 0 0 / 10%) !important;
          }
        }
      }

      .overlay {
        top: 81px
      }

      .speller {
        width: 100%;
        padding-left: 1.8rem;
      }
    }

  }


`;

const SearchBand = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  padding-top: 2rem;
  padding-bottom: 2rem;

  .related {
    position: relative;
    ${fontFamilyMedium};
    font-size: 13px;
    line-height: 19px;
    color: #7783A1;
    padding: 2rem 3rem 0;

    > div {
      display: flex;
      gap: 1rem;
      align-items: baseline;
    }

    div.related-tit {
      min-width: 24px
    }

    div.related-item {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;

      span {
        padding: 0.5rem 1rem 0.5rem 2rem;
        background: rgba(255, 255, 255, 0.3);
        border: 1px solid #CDD9EA;
        border-radius: 100px;

        ${fontFamilyMedium};
        font-size: 13px;
        line-height: 19px;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        img {
          margin-left: 2rem;
        }
      }
    }
  }


  .related-model {
    display: flex;
    margin-top: .5rem;
    margin-bottom: .5rem;

    ${fontFamilyMedium};
    font-size: 13px;
    line-height: 19px;
    display: flex;
    align-items: center;
    overflow: hidden;
    gap: .3rem;

    span {
      padding: 0.5rem 1rem 0.6rem 1rem;

      background: rgba(255, 255, 255, 0.3);
      border: 1px solid #CDD9EA;
      height: 1.6rem;
      border-radius: 100px;

      ${fontFamilyMedium};
      font-size: 1rem;
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .search_highlight {
        color: #909FB7;
      }
    }
  }

  .search-input-wrap {
    display: flex;
    justify-content: center;
  }

  .search-input-box {
    position: relative;

    .related-search-suggest-item {
      ${fontFamilyMedium};
      display: flex;
      align-items: center;
      height: 3.2rem;
      line-height: 1.4rem;
      letter-spacing: -0.04rem;
      margin-left: 0.2rem;

      .related-name {
        color: #2A2C2F;
        ${fontFamilyBold};

        span {
          color: #909FB7;
        }
      }
    }


    .category-search-suggest-item {
      ${fontFamilyMedium};
      height: 3.2rem;
      line-height: 1.4rem;
      display: flex;
      align-items: center;
      letter-spacing: -0.04rem;
      margin-left: 0.2rem;

      .parent-category {
        color: #909FB7;
        margin-right: 0.4rem;
      }

      .category-name {
        color: #2A2C2F;
        ${fontFamilyBold};

        span {
          color: #909FB7;
        }
      }
    }

    .model-search-suggest-item {
      ${fontFamilyMedium};
      display: flex;
      align-items: center;
      height: 3.2rem;
      line-height: 1.4rem;
      letter-spacing: -0.04rem;
      margin-left: 0.2rem;

      .model-name {
        span {
          color: #909FB7;
          ${fontFamilyMedium};
        }

        color: #2A2C2F;
        ${fontFamilyBold};
      }

      .parent-category {
        margin-left: 0.8rem;
        color: #909FB7;
        font-size: 1rem;
      }
    }

    .search-input {
      position: relative;
      width: 53.6rem;
      height: 6.2rem;
      background-color: #ffffff;
      ${fontFamilyMedium};
      font-size: 2rem;
      color: #2A2C2F;
      background-image: url(${SsqImages.header.icon.search()});
      background-position: center left 1.6rem;
      background-repeat: no-repeat;
      padding: 0 5rem 0 4.8rem;
      border-radius: 3.2rem 0 0 3.2rem !important;

      ::placeholder {
        font-size: 1.4rem;
        color: #666E7A;
        ${fontFamilyRegular};
      }
    }

    .close-small-icon-div {
      display: flex;
      align-items: center;
      background-color: #ffffff;
      position: absolute;
      right: 0;
      top: calc(50% - (2.4rem / 2));
      cursor: pointer;
      z-index: 12;

      .close-small-icon {
        width: 24px;
        height: 24px;
        margin-right: 2rem;
      }
    }

    .search-suggest {
      background-color: white;
      position: absolute;
      height: fit-content;
      max-height: calc(100vh - 15.2rem - 4rem);
      left: 3.2rem;
      bottom: 10rem;
      top: 6.4rem;
      overflow-x: hidden;
      //width: calc(54rem + 4.8rem);
      width: 50.4rem;
      box-shadow: inset 0px 4px 12px -4px rgb(0 0 0 / 10%);
      border-radius: 0 0 4px 4px;
      z-index: 15;

      > div:first-child .search-result-type {
        border: none !important;
      }

      .search-result-type {
        box-sizing: border-box;
        border-top: 1px solid #DDE2E9;
        width: 100%;
        padding: 0.8rem;
        text-align: left;
        font-size: 1rem;
        color: #909FB7;
      }

      .suggest-item {
        ${fontFamilyMedium};

        text-align: left;
        width: 100%;
        padding: 0rem 0.8rem;
        font-size: 1.3rem;
        display: flex;
        flex-direction: row;

        :hover {
          background: rgba(64, 126, 219, 0.1);
        }

        :active {
          background: rgba(64, 126, 219, 0.3);
        }

      }

      .suggest-item-selected {
        ${fontFamilyMedium};
        text-align: left;
        width: 100%;
        padding: 0rem 0.8rem;
        font-size: 1.3rem;
        line-height: 3.2rem;
        background: rgba(64, 126, 219, 0.3);
        display: flex;
        flex-direction: row;
      }

      .search-result {
        margin-right: 1rem;
        font-size: 1.3rem;
        text-align: left;
        line-height: 3.2rem;
        ${fontFamilyBold};
        color: #2A2C2F;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        img {
          vertical-align: middle;
        }
      }

      .search_highlight {
        color: #909FB7;
      }
    }

    .recent-search-suggest, .related-search-suggest, .search-suggest-category, .search-suggest-model {
      margin-bottom: 0.8rem;
    }
  }


  .search-button {
    width: 16rem;
    font-size: 16px;
    height: 6.4rem;
    color: white;
    background: linear-gradient(180deg, #5292F2 0%, #407EDB 100%);
    border-top-right-radius: 3.2rem;
    border-bottom-right-radius: 3.2rem;

    ${fontFamilyBold}
    :hover {
      background: linear-gradient(180deg, #407EDB 0%, #3B71C4 100%);
    }

    :active {
      background: linear-gradient(180deg, #3B71C4 0%, #3463AB 100%);
    }
  }

  @media screen and (max-width: 1199px) {
    display: block !important;
    width: 100% !important;
    height: auto !important;
    .search-button {
      width: 16rem
    }

    .search-input-wrap {
      max-width: 70rem;
      margin: 0 auto;
    }

    .search-input-box {
      width: calc(100% - 16rem);

      .search-input {
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 764px) {
    padding-top: 0;
    .related {
      > div {
        overflow-x: auto;
        flex-wrap: nowrap;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &:before {
        content: '';
        display: inline-block;
        width: 3rem;
        height: 100%;
        background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.99) 15px);
        position: absolute;
        top: 0;
        left: 1.5rem;
        z-index: 2;
      }

      &:after {
        content: '';
        display: inline-block;
        width: 3rem;
        height: 100%;
        background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.99) 15px);
        position: absolute;
        top: 0;
        right: 1.5rem;
        z-index: 2;
      }

      div.related-tit {
        z-index: 3;
      }

      div.related-item {
        flex-wrap: nowrap;
      }
    }
  }
`;
